import Bottom from './Bottom'

export * from './Bottom'

export default Bottom
